<div class="row">
  <div class="col-md-4 no-padding-right">
      <app-card [title]="(invoice?.mockInvoice?.customerDetail ? 'admin.order.customer_information': 'admin.backoffice.order.company_information')|translate">
        <div class="row">
          <div class="col-md-5 infobox">
            <p>{{ (invoice?.mockInvoice?.customerDetail ? 'doctrine.user.name' : 'doctrine.user.companyName')|translate}}</p>
            <p>{{'doctrine.user.address'|translate}}</p>
            <p>{{'doctrine.user.email'|translate}}</p>
            <p>{{'doctrine.user.phone'|translate}}</p>
            <p *ngIf="isCreditInvoice">{{'doctrine.user.invoice_number'|translate}}</p>
          </div>
          <div *ngIf="invoice?.mockInvoice?.customerDetail" class="col-md-7 infobox">
            <p>{{invoice.mockInvoice?.customerDetail?.fullName}}</p>
            <p>{{invoice.mockInvoice?.customerDetail?.street + ' ' + invoice.mockInvoice?.customerDetail?.houseNumber}}</p>
            <p>{{invoice.mockInvoice?.customerDetail?.email}}</p>
            <p>{{invoice.mockInvoice?.customerDetail?.phoneNumber}}</p>
            <p *ngIf="isCreditInvoice">{{invoice?.payload?.originalInvoiceId}}</p>
          </div>
          <div *ngIf="!invoice?.mockInvoice?.customerDetail" class="col-md-7 infobox">
            <p>{{invoice?.mockInvoice?.invoiceDealer?.companyName}}</p>
            <p>{{invoice?.mockInvoice?.invoiceDealer?.address}}</p>
            <p>{{invoice?.mockInvoice?.invoiceDealer?.email}}</p>
            <p>{{invoice?.mockInvoice?.invoiceDealer?.phone}}</p>
            <p *ngIf="isCreditInvoice">{{invoice?.payload?.originalInvoiceId}}</p>
          </div>
        </div>
      </app-card>
    </div>
  <div class="col-md-12">
    <app-card
      *ngIf="invoice?.additionalMockInvoice"
      [title]="pageTitle"
      [advanceButton]="true"
      [showActionButtons]="showActionButtons"
      [advancedButtons]="specialButton"
      [innerHtmlHeader]="headerContent"
      (outputButtonAdvance)="callFunction($event)"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive order-table">
            <table class="table table-order">
              <thead>
              <tr>
                <th>{{'doctrine.backoffice.order.description'| translate}}</th>
                <th>{{'doctrine.backoffice.order.amount'| translate}}</th>
                <th>{{'doctrine.backoffice.order.price'| translate}}</th>
                <th>{{'doctrine.backoffice.order.total'| translate}}</th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let item of invoice?.additionalMockInvoice?.customInvoiceItems;let first = first">
                <tr class="after-divider">
                  <td><span class=" ms-3">{{ item.description }}</span></td>
                  <td>{{ item.amount }}</td>
                  <td>{{ item.price | currency:'EUR':'symbol':'1.2-2' }}</td>
                  <td>{{ (item.amount * item.price) | currency:'EUR':'symbol':'1.2-2' }}</td>
                </tr>
              </ng-container>
              <ng-container *ngFor="let item of invoice?.additionalMockInvoice?.creditInvoiceItems;let first = first">
                <tr class="after-divider">
                  <td><span class=" ms-3">{{ item.description }}</span></td>
                  <td>{{ item.amount }}</td>
                  <td>{{ item.price | currency:'EUR':'symbol':'1.2-2' }}</td>
                  <td>-{{ (item.amount * item.price) | currency:'EUR':'symbol':'1.2-2' }}</td>
                </tr>
              </ng-container>

              <tr class="divider">
                <td></td>
                <td></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-md-3">
          <div class="table-responsive calculator-box">
            <table class="table table-sm">
              <tr>
                <td>{{'doctrine.backoffice.order.total_ex-vat'| translate}}</td>
                <td><span *ngIf="invoice?.additionalMockInvoice?.isCredit">-</span> {{ invoice?.additionalMockInvoice?.amountEx | currency:'EUR':'symbol':'1.2-2' }}</td>
              </tr>
              <tr>
                <td>{{'doctrine.backoffice.order.vat'| translate}} {{invoice?.additionalMockInvoice?.invoiceDealer?.salesVatPercentage}}%</td>
                <td><span *ngIf="invoice?.additionalMockInvoice?.isCredit">-</span> {{ (invoice?.additionalMockInvoice?.amount - invoice?.additionalMockInvoice?.amountEx) | currency:'EUR':'symbol':'1.2-2' }} </td>
              </tr>
              <tr>
                <td><strong>{{'doctrine.backoffice.order.total_price'| translate}}</strong></td>
                <td><strong><span *ngIf="invoice?.additionalMockInvoice?.isCredit">-</span>{{ invoice?.additionalMockInvoice?.amount | currency:'EUR':'symbol':'1.2-2' }}</strong></td>
              </tr>
            </table>
          </div>
        </div>
      </div>

    </app-card>
    <app-card
      [title]="pageTitle"
      [advanceButton]="true"
      [showActionButtons]="invoice?.additionalMockInvoice ? [] : showActionButtons"
      [advancedButtons]="invoice?.additionalMockInvoice ? [] : specialButton "
      [innerHtmlHeader]="headerContent"
      (outputButtonAdvance)="callFunction($event)"
      [ngClass]="{blur: invoice?.additionalMockInvoice}"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive order-table">
            <table class="table table-order">
              <thead>
                <tr>
                  <th>{{'doctrine.backoffice.order.description'| translate}}</th>
                  <th>{{'doctrine.backoffice.order.amount'| translate}}</th>
                  <th>{{'doctrine.backoffice.order.price'| translate}}</th>
                  <th>{{'doctrine.backoffice.order.total'| translate}}</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let item of invoice?.mockInvoice?.customInvoiceItems;let first = first">
                  <tr class="after-divider">
                    <td><span class=" ms-3">{{ item.description }}</span></td>
                    <td>{{ item.amount }}</td>
                    <td>{{ item.price | currency:'EUR':'symbol':'1.2-2' }}</td>
                    <td>{{ (item.amount * item.price) | currency:'EUR':'symbol':'1.2-2' }}</td>
                  </tr>
                </ng-container>
                <ng-container *ngFor="let item of invoice?.mockInvoice?.creditInvoiceItems;let first = first">
                  <tr class="after-divider">
                    <td><span class=" ms-3">{{ item.description }}</span></td>
                    <td>{{ item.amount }}</td>
                    <td>{{ item.price | currency:'EUR':'symbol':'1.2-2' }}</td>
                    <td>-{{ (item.amount * item.price) | currency:'EUR':'symbol':'1.2-2' }}</td>
                  </tr>
                </ng-container>

                <tr class="divider">
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-md-3">
          <div class="table-responsive calculator-box">
            <table class="table table-sm">
              <tr>
                <td>{{'doctrine.backoffice.order.total_ex-vat'| translate}}</td>
                <td><span *ngIf="invoice?.mockInvoice?.isCredit">-</span> {{ invoice?.mockInvoice?.amountEx | currency:'EUR':'symbol':'1.2-2' }}</td>
              </tr>
              <tr>
                <td>{{'doctrine.backoffice.order.vat'| translate}} {{invoice?.mockInvoice?.invoiceDealer?.salesVatPercentage}}%</td>
                <td><span *ngIf="invoice?.mockInvoice?.isCredit">-</span> {{ (invoice?.mockInvoice?.amount - invoice?.mockInvoice?.amountEx) | currency:'EUR':'symbol':'1.2-2' }} </td>
              </tr>
              <tr>
                <td><strong>{{'doctrine.backoffice.order.total_price'| translate}}</strong></td>
                <td><strong><span *ngIf="invoice?.mockInvoice?.isCredit">-</span>{{ invoice?.mockInvoice?.amount | currency:'EUR':'symbol':'1.2-2' }}</strong></td>
              </tr>
            </table>
          </div>
        </div>
      </div>

    </app-card>
  </div>
</div>


<app-generate-invoice #editCustomInvoiceModal="generateInvoice" [invoiceLayout]="invoice?.payload?.form?.invoiceLayout"  [customInvoice]="invoice?.mockInvoice" [invoiceId]="draftInvoiceId"
 (resultInvoice)="onInvoiceEdited ($event)" [isCreditInvoice]="isCreditInvoice" [originalInvoiceId]="invoice?.payload?.originalInvoiceId"></app-generate-invoice>

 <app-modal-basic #approveModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.approve_draft_invoice' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="approveModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.approve_draft_invoice_body' | translate}}</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="approveModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" (click)="approveDraft()" [disabled]="isApprovingDraft">{{'global.yes'|translate}}</button>
  </div>
</app-modal-basic>

<app-modal-basic #rejectModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.reject_draft_invoice' | translate}}</h4>
    <button type="button" class="close basic-close" (click)="rejectModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.reject_draft_invoice_body' | translate}}</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="rejectModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" (click)="rejectDraft()">{{'global.yes'|translate}}</button>
  </div>
</app-modal-basic>
